import {Migration} from "@app/core/shared/infrastructure/migration/interfaces/migration";
import {MigrationContext} from "@app/core/shared/infrastructure/migration/interfaces/migration-context";

/**
 * Object to orchestrate the migrations execution.
 */
export class MigrationsExecutor {
  readonly context: MigrationContext;
  readonly migrations: Migration[];
  constructor(context: MigrationContext, migrations: Migration[]) {
    this.context = context;

    // Sort the migrations by version to ensure they are executed in the correct order
    this.migrations = [...migrations].sort((a, b) => a.version - b.version);
  }
  async execute() {
    const userDBVersion = this.context.oldVersion;
    for (const migration of this.migrations) {
        
      // Execute the migration if the user's db version is less than the migration version
      const shouldExecuteMigration = userDBVersion <= migration.version;
      if (shouldExecuteMigration) {
        await migration.updateFn(this.context);
      }
    }
  }
}
